import { Button, ConfirmModal, Panel, Table } from '@/components/Bicester';
import { PopoverWrapper } from '@/components/Bicester/PopoverWrapper';
import { Cell } from '@/components/Bicester/Table';
import { DateTimeCell, UserNameCell } from '@/components/Bicester/Table/Cells';
import { BICESTER_FULL_DATE } from '@/constants/dateFormat';
import { SERVICE_STATUS } from '@/services/constants';
import { fetchSendTicket } from '@/services/exchange';
import { useModal } from '@ebay/nice-modal-react';
import { useRequest } from 'ahooks';
import dayjs from 'dayjs';
import React from 'react';
import { Alert } from 'rsuite';

const SendTicketList = ({
  data,
  loading,
  onChange,
  onReSearch,
}: {
  data: any;
  loading: boolean;
  onChange: (params: any) => void;
  onReSearch?: () => void;
}) => {
  const modal = useModal(ConfirmModal);

  const { run: sendTicket, loading: sendTicketLoading } = useRequest(fetchSendTicket, {
    manual: true,
  });

  return (
    <Panel
      leftShadow
      title="活动发券"
      subTitle={`总计 ${data?.total || 0} 条`}
      loading={sendTicketLoading}
    >
      <Table
        pageInfo={{ page: data?.current_page, total: data?.total }}
        data={data?.content_list}
        loading={loading}
        columns={[
          {
            columnProps: {
              flexGrow: 1.5,
            },
            header: '参与时间',
            cell: <DateTimeCell dataKey="create_at" />,
          },
          {
            columnProps: {
              flexGrow: 1,
            },
            header: '客户名',
            cell: <UserNameCell dataKey="user_name" />,
          },
          {
            columnProps: {
              flexGrow: 1.5,
            },
            header: '手机号',
            cell: <Cell dataKey="phone" />,
          },
          {
            columnProps: {
              flexGrow: 4,
            },
            header: '活动名/渠道',
            cell: (
              <Cell>
                {(rowData) => (
                  <PopoverWrapper
                    popover={{
                      content: (
                        <div className="text-[#455255]">
                          {rowData?.title && <div>{rowData?.title}</div>}
                          {(rowData?.channel_level1 || rowData?.channel_level2) && (
                            <div>
                              渠道：{rowData?.channel_level1},{rowData?.channel_level2}
                            </div>
                          )}
                        </div>
                      ),
                    }}
                  >
                    <div className="multiline-cell-content-wrap">
                      {rowData?.title && (
                        <div className="multiline-cell-content">{rowData?.title}</div>
                      )}
                      {(rowData?.channel_level1 || rowData?.channel_level2) && (
                        <div className="multiline-cell-content">
                          渠道：{rowData?.channel_level1},{rowData?.channel_level2}
                        </div>
                      )}
                    </div>
                  </PopoverWrapper>
                )}
              </Cell>
            ),
          },
          {
            columnProps: {
              flexGrow: 1.5,
            },
            header: '参与方式',
            cell: <Cell dataKey="is_new_name" />,
          },
          {
            columnProps: {
              flexGrow: 2,
            },
            header: '活动有效期',
            cell: (
              <Cell>
                {(rowData) => {
                  return (
                    <div className="multiline-cell-content-wrap">
                      {rowData?.start_at && (
                        <div className="multiline-cell-content">
                          开始{dayjs(rowData?.start_at).format(BICESTER_FULL_DATE)}
                        </div>
                      )}
                      {rowData?.end_at && (
                        <div className="multiline-cell-content">
                          结束{dayjs(rowData?.end_at).format(BICESTER_FULL_DATE)}
                        </div>
                      )}
                    </div>
                  );
                }}
              </Cell>
            ),
          },
          {
            columnProps: {
              flexGrow: 1,
            },
            header: '操作/记录',
            cell: (
              <Cell>
                {(rowData) =>
                  rowData?.is_send === 1 ? (
                    '已发券'
                  ) : (
                    <Button
                      appearance="link"
                      onClick={() => {
                        modal.show({
                          isInput: true,
                          contentText: (
                            <>
                              <div className="h-[40px] leading-[40px]">
                                活动名：{rowData?.title}
                              </div>
                              <div className="h-[40px] leading-[40px]">确定发券？</div>
                            </>
                          ),
                          submitText: '确定',
                          cancelText: '取消',
                          onSubmit: () => {
                            sendTicket(rowData?.act_member_id).then((res) => {
                              if (res?.status === SERVICE_STATUS.SUCCESS) {
                                Alert.success('发券成功');
                                onReSearch();
                              }
                            });
                          },
                        });
                      }}
                    >
                      发券
                    </Button>
                  )
                }
              </Cell>
            ),
          },
        ]}
        onChange={onChange}
      >
        <Table.Body height={289} rowHeight={64} />
        <Table.Pagination style={{ ...(data?.total === 0 && { visibility: 'hidden' }) }} />
      </Table>
    </Panel>
  );
};

export default SendTicketList;
